export default "###### Let us know who you are\n\nProvide us with your name, email and phone number so we can chat to you about your trade in offer.\n";